import React, { useMemo } from 'react';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getDisponibilidadeFrotaColumns } from './tanStackColumnsFrota';
import { getVeiculoRowId } from '../utils/mappers';

const DisponibilidadeFrotaTable = ({
  data,
  loading,
  totalRegistros,
  paginaAtual,
  quantidadePorPagina,
  setPaginaAtual,
  setQuantidadePorPagina,
  enableCardView = false,
  defaultViewMode = 'table',
  renderCard,
  onRowClick,
  onPositionClick,
  getPositionStatus,
  getPositionTooltip,
  showPositionColumn = false,
  showPlotagemColumn = false,
  showTipoOperacaoColumn = true,
  columnConfigKey
}) => {
  const pageIndex = Math.max(0, (paginaAtual || 1) - 1);
  const pageSize = quantidadePorPagina || 5;
  const paginatedData = useMemo(() => {
    const start = pageIndex * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, pageIndex, pageSize]);

  return (
    <TanStackTable
      columns={getDisponibilidadeFrotaColumns({
        onPositionClick,
        showPositionColumn,
        showPlotagemColumn,
        showTipoOperacaoColumn,
        getPositionStatus,
        getPositionTooltip
      })}
      data={paginatedData}
      getRowId={getVeiculoRowId}
      isSortable={true}
      withPagination={true}
      pageSizeOptions={[5, 10, 25, 50, 100]}
      enableRowColors={true}
      loading={!!loading}
      className="mt-3"
      manualPagination={true}
      totalItems={totalRegistros}
      enableColumnConfig={true}
      columnConfigKey={columnConfigKey}
      enableCardView={enableCardView}
      enableCopy={true}
      defaultViewMode={defaultViewMode}
      renderCard={renderCard}
      onRowClick={onRowClick}
      controlledPagination={{
        pageIndex,
        pageSize
      }}
      onPaginationChange={next => {
        if (next && typeof next.pageSize === 'number') {
          setQuantidadePorPagina(next.pageSize);
        }

        if (next && typeof next.pageIndex === 'number') {
          setPaginaAtual(next.pageIndex + 1);
        }
      }}
    />
  );
};

export default DisponibilidadeFrotaTable;
